export default __webpack_public_path__ + "static/media/image@3x.0466f728.png";